module.exports = __webpack_public_path__ + "static/media/prompt.1a083e49.png";